import React, { useState } from "react";
import "../css/login.css";
import axios from "axios";
import { Link } from "react-router-dom";
import { backend_url } from "../App.js";

function Verify() {                
    let verify = async () => {
        try {
            // Get token from url
            let current_url = window.location.href.split("/");
            let tok = current_url[current_url.length - 1];

            // Send request to verify user
            const response = await axios.post(backend_url + 'verifyUser', { 
                token: tok
            });
        } 
        catch (error) {
            console.error(error);
        }
    }

    window.onload = function() {
        verify();
    }

    return (
        <>
                <>
                    <meta charSet="UTF-8" />
                    <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
                    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                    <title>Verify</title>
                    <link href='https://unpkg.com/boxicons@2.1.4/css/boxicons.min.css' rel='stylesheet' />
                    <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;600;700&display=swap"
                        rel="stylesheet" />
                    <link rel="preconnect" href="https://fonts.googleapis.com" />
                    <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
                </>
                <section className="container">
                        <div className="form login">
                            <div className="form-content">
                                <header>Success!</header>
                                <p>Your account has been successfully verified</p>
                                <div className="form-link">
                                    <span>Go Back to <Link to='/' className="link sign-up-link"> Login </Link></span>
                                </div>
                            </div>
                        </div>
                    </section>
        </>
    );
}

export default Verify;